import { CreativeServerGenConfig } from "../Creative/CreativeServer";
import { ScheduleProgram } from "../Schedule/Schedule";
import { GetNationalActivity, InstantActivity } from "../Schedule/ScheduleActivity";
import { UserData } from "../UserData";
import { CloneActivityPackage, CloneChat, ContentEnvironment, ContentPackageConfigData } from "./ContentPackage";
import { ActivityBlockConfigData, ChatConfigData, Media, PartyConfigData, PostConfigData } from "./PartyConfigData";


export type ContextTrigger = { 
    itemId : string;
    time : number;
    deactivate : number;
    fired? : boolean;
}
export type ContentContextData = {
    itemId: string;
    title: string;
    image: string;
    description: string;
    startTime: number;
    endTime: number;
    media: Media[];
    optional: { [key: string]: ActivityBlockConfigData }
    chats: { [key: string]: ChatConfigData }
    schedule: ScheduleProgram[];
    triggers : ContextTrigger[];
    creativeServerConfigs? : { [key : string] : CreativeServerGenConfig};
}



export const DefaultContentContextData = () : ContentContextData => {
    return {
        itemId : '',
        title : '',
        image : '',
        description : '',
        startTime : 0,
        endTime : 0,
        media : [],
        optional : {},
        chats : {},
        schedule : [],
        triggers : []
    }
}

export const ExtractContentContext = (party : PartyConfigData, environment : ContentEnvironment, schedule : ScheduleProgram[]) : ContentContextData => {

    const endMain = party.main.length === 0 ? 0 : party.main[party.main.length - 1].endTime;
    var endChat = 0;
    Object.keys(party.chats).forEach((key) => {
        endChat = Math.max(endChat, party.chats[key].endTime);
    });

    var endMedia = 0;
    party.media.forEach((m)=> {
        endMedia+= Math.floor(m.length);
    });

    const end = Math.max(endMain, endChat, endMedia);

    const activity0 = GetNationalActivity(environment.daily, environment.startTime);

    const optionals : {[key : string] : ActivityBlockConfigData} = {};
    Object.keys(party.optional).forEach((key)=> {
        const pac = party.optional[key];
        var online = activity0;
        if(pac.startTime > 60000)
            online = GetNationalActivity(environment.daily, environment.startTime + pac.startTime);
        optionals[key] = CloneActivityPackage(pac, environment, online);
    });

    const chats : {[key : string] : ChatConfigData} = {};
    Object.keys(party.chats).forEach((key) => {
        var found = false;
        party.main.forEach((activity) => {
            if(activity.activityType === 'post')
            {
                const post = activity.config as PostConfigData;
                if(post.chatId !== undefined)
                {
                    found = found || (key === post.chatId);
                }
            }
            
        });
        if(!found)
        {
            chats[key] = CloneChat(party.chats[key], 0, end, 3, environment.startTime, activity0);
        }
    })

    

    const ret : ContentContextData = {
        itemId : party.itemId,
        title : party.title,
        image : party.image,
        description : party.description,
        startTime : environment.startTime,
        endTime :  end + environment.startTime,
        media : party.media.map((m)=> CloneMedia(m,environment)),
        optional : optionals,
        chats : chats,
        schedule : schedule,
        triggers : party.triggers.map((trigger) : ContextTrigger=> { return { itemId : trigger.itemId, time : trigger.time + environment.startTime, deactivate : trigger.deactivate + environment.startTime}}),
        creativeServerConfigs : environment.creativeServerConfigs
    }
    return ret;

}

const CloneMedia = (media : Media, environment : ContentEnvironment) : Media => {
    return {
        mediaType : media.mediaType,
        url : media.url,
        length : media.length,
        startTime : media.startTime + environment.startTime
    }
}

export type ContentServerPackage = {
    content: ContentPackageConfigData;
    context?: ContentContextData;
    activity: InstantActivity;
    userData?: UserData;
}